<template>
    <v-container>
        <v-card flat class="text-xs-center" width="100%">
            <v-card-title class="justify-center primary">
                <v-toolbar-title id="titulocard">Datos Contacto </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <div v-if="aiclave != 5">
                    <span style="font-size: initial;">Contacto Inteligente</span>
                    <vs-list>
                        <vs-list-item title="Llamarán del Teléfono:"
                            :subtitle="this.contactoInteligente"></vs-list-item>
                        <vs-list-item title="Teléfono Fijo:" subtitle="5550616100"></vs-list-item>
                    </vs-list>
                </div>
                <v-form ref="form1" v-model="valid1" lazy-validation>
                    <v-row class="mb-1">
                        <template v-if="validaConclusion">
                            <v-col cols="2" style="display: grid; place-items: center; padding: 0px !important"
                                v-if="showMover">
                                <v-btn icon color="primary" title="Cambiar Orden" @click="showMover = !showMover">
                                    <v-icon color>mdi-cursor-move</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="2" style="display: grid; place-items: center; padding: 0px !important" v-else>
                                <v-btn icon color="error" title="Cancelar Orden" @click="showMover = !showMover">
                                    <v-icon color>mdi-close</v-icon>
                                </v-btn>
                            </v-col>
                        </template>
                        <v-col cols="10">
                            <span style="font-size: initial;">Teléfonos</span>
                        </v-col>
                    </v-row>
                    <draggable v-model="datosActor" @change="CambioPosicionActor(0)"
                        :style="{ cursor: showMover ? 'default' : 'grab' }" :disabled="showMover">
                        <v-card v-for="(item, i) in datosActor" :key="'A' + (i + 1)" class="mt-2">
                            <v-card-title class="justify-center " style="border-bottom: 4px solid #536DFE !important ">
                                <v-toolbar-title style="font-size:20px">
                                    <v-icon> mdi-compare-vertical</v-icon>
                                    {{ item.stadescripcion }}
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon color="primary" title="Editar"
                                    v-if="showEditarActor && item.staid != 10 && validaConclusion"
                                    @click="EditarActor(item, i)">
                                    <v-icon color small>mdi-lead-pencil</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-card-text>
                                <div v-if="item.showEditarActor == 0">
                                    <vs-list-item title="Nombre: " id="actornombre"
                                        :subtitle="item.sanombre"></vs-list-item>
                                    <vs-list-item title="Horario:"></vs-list-item>
                                    <v-textarea outlined filled v-model="item.sahorarios" rows="3" name="input-7-4"
                                        readonly>
                                    </v-textarea>
                                    <v-divider></v-divider>
                                    <draggable v-model="telefonos" @change="CambioOrdenTel(datosActor[i].staid)"
                                        :disabled="showMover">
                                        <div v-for="(telefono, index) in telefonos" :key="index">
                                            <vs-list v-if="telefono.staid == datosActor[i].staid">
                                                <v-list-item-content
                                                    v-if="telefono.showEditar == 0 && telefono.verOculto == 0">
                                                    <v-list-item-subtitle>
                                                        <vs-col vs-lg="8" style="margin-top: 5px;">
                                                            <v-btn icon color="primary" title="SMS"
                                                                @click="EnviarMsj(telefono.stnumero)">
                                                                <v-icon color="indigo">{{ telefono.icon }}</v-icon>
                                                            </v-btn>
                                                            <span class="hoverTel" v-if="permisoIVR"
                                                                style="font-size: 15.5px; text-align: center;"
                                                                v-on:click="LlamadaIVR(telefono)">
                                                                {{ telefono.Column1 }}
                                                                {{
                                                                    ocultartele(separarNumeroTelefono(telefono.stnumero.substring(0,
                                                                        6)))
                                                                }}
                                                                {{
                                                                    separarNumeroTelefono(telefono.stnumero.substring(6,
                                                                        10))
                                                                }}
                                                            </span>
                                                            <span v-else style="font-size: 15.5px; text-align: center;">

                                                                {{ telefono.Column1 }}
                                                                {{
                                                                    ocultartele(separarNumeroTelefono(telefono.stnumero.substring(0,
                                                                        6)))
                                                                }}
                                                                {{
                                                                    separarNumeroTelefono(telefono.stnumero.substring(6,
                                                                        10))
                                                                }}
                                                            </span>
                                                        </vs-col>
                                                        <vs-col class="ml-2" vs-lg="1"
                                                            v-if="showEditar && !showAgregar && permisoTelf == 1 && validaConclusion">

                                                            <v-btn icon @click="eliminaTelf(telefono, index)"
                                                                title="Eliminar" color="red">
                                                                <v-icon small>mdi-delete</v-icon>
                                                            </v-btn>
                                                        </vs-col>
                                                        <vs-col vs-lg="1">
                                                            <v-btn v-if="permisoOfuscar" icon id="veri"
                                                                @click="VerModal(telefono, index, '')"
                                                                title="Ver teléfono"
                                                                color="primary"><v-icon>mdi-eye</v-icon></v-btn>
                                                        </vs-col>
                                                        <vs-col vs-lg="1"
                                                            v-if="showEditar && !showAgregar && validaConclusion && permisoCita"
                                                            title="Recordatorio">
                                                            <v-btn icon color="secondary" @click="dialogCita(telefono)">
                                                                <v-icon>mdi-calendar-alert</v-icon>
                                                            </v-btn>
                                                        </vs-col>
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-col md="12"
                                                    v-if="telefono.showEditar == 1 && telefono.staid == datosActor[i].staid">
                                                    <span style="text-align: center;">Actor:</span>
                                                    <multiselect v-model="actores.staid"
                                                        deselect-label="No se puede remover el valor seleccionado"
                                                        selected-label="Seleccionado" track-by="staid"
                                                        label="stadescripcion" placeholder=""
                                                        :options="actores.opcionesActores" :allow-empty="false">
                                                    </multiselect>
                                                    <div v-if="validaActor">
                                                        <span class='spanError' style=' color:red; font-size:11px'>
                                                            Campo
                                                            requerido
                                                        </span>
                                                        <br />
                                                    </div>
                                                    <span style="text-align: center;">Tipo:</span>
                                                    <multiselect v-model="tipotelf.sttid"
                                                        deselect-label="No se puede remover el valor seleccionado"
                                                        selected-label="Seleccionado" track-by="sttid"
                                                        label="sttdescripcion" placeholder=""
                                                        :options="tipotelf.opcionestipotelf" :allow-empty="false">
                                                    </multiselect>
                                                    <div v-if="validaTipo">
                                                        <span class='spanError' style='color:red;font-size:11px'>
                                                            Campo
                                                            requerido
                                                        </span>
                                                        <br />
                                                    </div>
                                                    <span style="text-align: center;">Número:</span>

                                                    <vue-tel-input-vuetify v-model="numtelf" id="telprueba"
                                                        :error-messages="errorTelf" @input="onInput" outlined label=""
                                                        autocomplete="off" loading="true" max="10" required
                                                        placeholder="" :defaultCountry="telefono.country"
                                                        validCharactersOnly="false"
                                                        v-on:country-changed="countryChanged"
                                                        dense></vue-tel-input-vuetify>
                                                    <span v-if="validaTelefono" class='spanError'
                                                        style=' color:red;font-size:11px'>Modifique al menos un
                                                        dato</span>
                                                    <div v-if="mostrarnomhorario">
                                                        <span style="text-align: center; ">Nombre:</span>
                                                        <vs-input class="inputx" style="width:100%" maxlength="30"
                                                            v-model="nombre" autofocus />
                                                        <span style="text-align: center;">
                                                            Horario de
                                                            Contacto:
                                                        </span>
                                                        <div>
                                                            <v-textarea :counter="500" outlined v-model="horario"
                                                                rows="3" name="input-7-4" maxlength="500">
                                                            </v-textarea>
                                                        </div>
                                                    </div>
                                                    <v-row justify="end">
                                                        <v-btn icon class="ma-1"
                                                            @click="guardarEdicion(telefono, index)" title="Guardar"
                                                            color="primary" :disabled="disabledSave">
                                                            <v-icon>mdi-content-save</v-icon>
                                                        </v-btn>
                                                        <v-btn icon class="ma-1"
                                                            @click="cancelarEdicion(telefono, index)" title="Cancelar"
                                                            color="red" id="returnedit" :disabled="disabledSave">
                                                            <v-icon>mdi-keyboard-return</v-icon>
                                                        </v-btn>
                                                    </v-row>
                                                </v-col>
                                                <v-list-item-content
                                                    v-if="telefono.verOculto == 1 && telefono.showEditar == 5">
                                                    <v-list-item-subtitle>
                                                        <vs-col vs-lg="9" style="margin-top: 5px;">
                                                            <v-icon color="indigo">{{ telefono.icon }} </v-icon>
                                                            <span v-if="permisoIVR" class="hoverTel"
                                                                style="font-size: 15.5px; text-align: center;"
                                                                v-on:click="LlamadaIVR(telefono)">
                                                                {{ telefono.Column1 }}
                                                                {{ separarNumeroTelefono(telefono.stnumero) }}
                                                            </span>
                                                            <span v-else style="font-size: 15.5px; text-align: center;">

                                                                {{ telefono.Column1 }}
                                                                {{ separarNumeroTelefono(telefono.stnumero) }}
                                                            </span>
                                                        </vs-col>
                                                        <vs-col class="ml-2" vs-lg="1"
                                                            v-if="showEditar && !showAgregar && permisoTelf == 1 && validaConclusion">

                                                            <v-btn icon @click="eliminaTelf(telefono, index)"
                                                                title="Eliminar" color="red">
                                                                <v-icon small>mdi-delete</v-icon>
                                                            </v-btn>
                                                        </vs-col>
                                                        <vs-col vs-lg="1">
                                                            <v-btn v-if="permisoOfuscar" icon id="veri"
                                                                @click="OcultaTel(telefono, index, '')"
                                                                title="Ver teléfono"
                                                                color="primary"><v-icon>mdi-eye-off</v-icon></v-btn>
                                                        </vs-col>
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </vs-list>
                                        </div>
                                    </draggable>
                                </div>
                                <div v-if="item.showEditarActor == 1">
                                    <span style=" text-align: center; ">Nombre:</span>
                                    <v-text-field style="width:100%" v-model="nombre" outlined maxlength="30" autofocus
                                        @keydown.enter.prevent>
                                    </v-text-field>
                                    <span style=" text-align: center;">Horario de Contacto:</span>
                                    <div>
                                        <v-textarea :counter="500" outlined v-model="horario" rows="3" name="input-7-4"
                                            maxlength="500">
                                        </v-textarea>
                                    </div>
                                    <div v-if="erroractor != null">
                                        <span class='spanError' style='color:red;font-size:11px'>{{ erroractor }}</span>
                                        <br />
                                    </div>
                                    <v-spacer></v-spacer>
                                    <v-row justify="end" class="mt-1">
                                        <v-btn icon class="ma-1" @click="guardarEdicionActor(item, i)" title="Guardar"
                                            color="primary" :disabled="disabledSaveA">
                                            <v-icon>mdi-content-save</v-icon>
                                        </v-btn>
                                        <v-btn icon class="ma-1" @click="cancelarEdicionActor(item, i)" title="Cancelar"
                                            color="red" :disabled="disabledSaveA">
                                            <v-icon>mdi-keyboard-return</v-icon>
                                        </v-btn>
                                    </v-row>
                                </div>
                            </v-card-text>
                        </v-card>
                    </draggable>
                </v-form>
                <v-row justify="end" v-if="valagregar && permisoTelf == 1 && (validaConclusion || permisoTelRepConcluido)">
                    <v-col align="right">
                        <v-btn small class="ma-1" title="Agregar Telefono" color="primary" @click="agregarTelf()">
                            <v-icon color="white">
                                mdi-plus
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-col md="12" v-if="showAgregar">
                    <span style="text-align: center;">Actor:</span>
                    <multiselect v-model="actores.staid" deselect-label="No se puede remover el valor seleccionado"
                        selected-label="Seleccionado" track-by="staid" label="stadescripcion" placeholder=""
                        :options="actores.opcionesActores" :allow-empty="false">
                    </multiselect>
                    <div v-if="validaActor">
                        <span class='spanError' style='color:red;font-size:11px'>Campo requerido</span>
                        <br />
                    </div>
                    <span style=" text-align: center;">Tipo:</span>
                    <multiselect v-model="tipotelf.sttid" deselect-label="No se puede remover el valor seleccionado"
                        selected-label="Seleccionado" track-by="sttid" label="sttdescripcion" placeholder=""
                        :options="tipotelf.opcionestipotelf" :allow-empty="false">
                    </multiselect>
                    <div v-if="validaTipo">
                        <span class='spanError' style='color:red;font-size:11px'>Campo requerido</span>
                        <br />
                    </div>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <span style="text-align: center;">Número:</span>

                        <vue-tel-input-vuetify v-model="numtelf" @input="onInput" :error-messages="errorTelf"
                            autocomplete="off" outlined label="" loading="true" placeholder="" max="10" required
                            defaultCountry="MX" validCharactersOnly="false" v-on:country-changed="countryChanged"
                            dense></vue-tel-input-vuetify>
                        <span v-if="validaTelefono" class='spanError' style="color:red;font-size:11px">
                            Teléfono
                            inválido
                        </span>
                        <div v-if="mostrarnomhorario">
                            <span style="text-align: center; ">Nombre:</span>
                            <vs-input class="inputx" style="width:100%" v-model="nombre" maxlength="30" />
                            <span style="text-align: center;">Horario de Contacto:</span>
                            <div>
                                <v-textarea :counter="500" outlined v-model="horario" rows="3" name="input-7-4"
                                    maxlength="500">
                                </v-textarea>
                            </div>
                        </div>
                    </v-form>
                    <v-row justify="end">
                        <v-btn icon class="ma-1" @click="validacionAgregar()" title="Guardar" color="primary"
                            :disabled="disabledSave">
                            <v-icon>mdi-content-save</v-icon>
                        </v-btn>
                        <v-btn icon class="ma-1" @click="cancelarAlta()" title="Cancelar" color="red"
                            :disabled="disabledSave">
                            <v-icon>mdi-keyboard-return</v-icon>
                        </v-btn>
                    </v-row>
                </v-col>
                <v-card v-if="sindefinir" class="mt-2">
                    <v-card-title class="justify-center " style="border-bottom: 4px solid #536DFE !important ">
                        <v-toolbar-title style="font-size:20px">Por Definir</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text>
                        <vs-list v-for="(telefono, index) in telsindef" :key="index">
                            <v-list-item-content v-if="telefono.showEditar == 0">
                                <v-list-item-subtitle>
                                    <v-row>
                                        <v-col cols="12" md="7" style="margin-top: 5px;">
                                            <v-icon color="indigo">{{ telefono.icon }} </v-icon>
                                            <span class="hoverTel" v-if="permisoIVR"
                                                style="font-size: 15.5px; text-align: center;"
                                                v-on:click="LlamadaIVR(telefono)">
                                                {{ telefono.Column1 }}
                                                {{
                                                    ocultartele(separarNumeroTelefono(telefono.stnumero.substring(0,
                                                        6)))
                                                }}
                                                {{
                                                    separarNumeroTelefono(telefono.stnumero.substring(6,
                                                        10))
                                                }}
                                            </span>
                                            <span v-else style="font-size: 15.5px; text-align: center;">

                                                {{ telefono.Column1 }}
                                                {{
                                                    ocultartele(separarNumeroTelefono(telefono.stnumero.substring(0,
                                                        6)))
                                                }}
                                                {{
                                                    separarNumeroTelefono(telefono.stnumero.substring(6,
                                                        10))
                                                }}
                                            </span>
                                            <!-- <span
                                                style="font-size: 15.5px; text-align: center;  max-width: -webkit-fill-available !important;">
                                                {{ telefono.Column1 }}
                                                {{ ocultartele(telefono.stnumero.substring(0, 6)) }}
                                                {{ telefono.stnumero.substring(6, 10) }}
                                            </span> -->
                                        </v-col>
                                        <v-col cols="12" md="5">
                                            <v-btn icon @click="eliminaTelf(telefono, index)" title="Eliminar"
                                                color="red"
                                                v-if="showEditar && !showAgregar && permisoTelf == 1 && validaConclusion">
                                                <v-icon small>mdi-delete</v-icon>
                                            </v-btn>
                                            <v-btn icon v-if="permisoOfuscar" id="veri"
                                                @click="VerModal(telefono, index, 'SD')" title="Ver teléfono"
                                                color="primary"><v-icon>mdi-eye</v-icon></v-btn>
                                            <v-btn icon @click="editaTelfSinDef(telefono, index)" title="Editar"
                                                color="indigo">
                                                <v-icon small>mdi-lead-pencil</v-icon>
                                            </v-btn>
                                            <v-btn icon color="secondary" @click="dialogCita(telefono)"
                                                v-if="validaConclusion && permisoCita" title="Recordatorio">
                                                <v-icon>mdi-calendar-alert</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-col md="12" v-if="telefono.showEditar == 1">
                                <span style="text-align: center;">Actor:</span>
                                <multiselect v-model="actores.staid"
                                    deselect-label="No se puede remover el valor seleccionado"
                                    selected-label="Seleccionado" track-by="staid" label="stadescripcion" placeholder=""
                                    :options="actores.opcionesActores" :allow-empty="false">
                                </multiselect>
                                <div v-if="validaActor">
                                    <span class='spanError' style=' color:red; font-size:11px'>Campo requerido</span>
                                    <br />
                                </div>
                                <span style="text-align: center;">Tipo:</span>
                                <multiselect v-model="tipotelf.sttid"
                                    deselect-label="No se puede remover el valor seleccionado"
                                    selected-label="Seleccionado" track-by="sttid" label="sttdescripcion" placeholder=""
                                    :options="tipotelf.opcionestipotelf" :allow-empty="false">
                                </multiselect>
                                <div v-if="validaTipo">
                                    <span class='spanError' style="color:red;font-size:11px">Campo requerido</span>
                                    <br />
                                </div>
                                <span style="text-align: center;">Número:</span>
                                <br>
                                <span style="font-size: 15.5px; text-align: center;">
                                    {{ telefono.Column1 }}
                                    {{
                                        ocultartele(separarNumeroTelefono(telefono.stnumero.substring(0,
                                            6)))
                                    }}
                                    {{
                                        separarNumeroTelefono(telefono.stnumero.substring(6,
                                            10))
                                    }}
                                </span>
                                <div v-if="mostrarnomhorario">
                                    <span style="text-align: center; ">Nombre:</span>
                                    <vs-input class="inputx" style="width:100%" v-model="nombre" maxlength="30" />
                                    <span style="text-align: center;">Horario de Contacto:</span>
                                    <div>
                                        <v-textarea :counter="500" outlined v-model="horario" rows="3" name="input-7-4"
                                            maxlength="500">
                                        </v-textarea>
                                    </div>
                                </div>
                                <v-row justify="end">
                                    <v-btn icon class="ma-1" @click="guardarEdicionSD(telefono, index)" title="Guardar"
                                        color="primary" :disabled="disabledSave">
                                        <v-icon>mdi-content-save</v-icon>
                                    </v-btn>
                                    <v-btn icon class="ma-1" @click="cancelarEdicionSD(telefono, index)"
                                        title="Cancelar" color="red" id="returnedit" :disabled="disabledSave">
                                        <v-icon>mdi-keyboard-return</v-icon>
                                    </v-btn>
                                </v-row>
                            </v-col>
                            <v-list-item-content v-if="telefono.verOculto == 1 && telefono.showEditar == 5">
                                <v-list-item-subtitle>
                                    <vs-col vs-lg="9" style="margin-top: 5px;">
                                        <v-icon color="indigo">{{ telefono.icon }} </v-icon>
                                        <span v-if="permisoIVR" style="font-size: 15.5px; text-align: center;"
                                            v-on:click="LlamadaIVR(telefono)">
                                            {{ telefono.Column1 }}
                                            {{ telefono.stnumero }}
                                        </span>
                                        <span v-else style="font-size: 15.5px; text-align: center;">

                                            {{ telefono.Column1 }} >{{ telefono.stnumero }}
                                        </span>
                                    </vs-col>
                                    <vs-col class="ml-2" vs-lg="1"
                                        v-if="showEditar && !showAgregar && permisoTelf == 1 && validaConclusion">

                                        <v-btn icon @click="eliminaTelf(telefono, index)" title="Eliminar" color="red">
                                            <v-icon small>mdi-delete</v-icon>
                                        </v-btn>
                                    </vs-col>
                                    <vs-col vs-lg="1">
                                        <v-btn icon id="veri" v-if="permisoOfuscar"
                                            @click="OcultaTel(telefono, index, 'SD')" title="Ver teléfono"
                                            color="primary"><v-icon>mdi-eye-off</v-icon></v-btn>
                                    </vs-col>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </vs-list>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
        <div>
            <v-dialog transition="dialog-top-transition" persistent max-width="600" v-model="modal">
                <v-card>
                    <v-toolbar color="primary" dark>Firma Electrónica</v-toolbar>
                    <v-card-text>
                        <label style="font-style: italic; color:darkred">
                            Para ver los números de teléfono es necesario
                            ingresar su firma electrónica
                        </label>
                        <br />
                        <label> Firma electrónica: </label>
                        <br />
                        <v-text-field id="firma" ref="input" v-model="firma" autocomplete="off" maxlength="17"
                            style="-webkit-text-security: disc;" @focus="Foco()" autofocus solo></v-text-field>
                        <span v-if="msg" id="revfirmaelectronica" style="font-style: italic; color: red">{{ texto
                            }}</span>
                        <br />
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn @click="CerrarModal()">Cerrar</v-btn>
                        <v-btn @click="ValidarFirma()" color="primary" :loading="loading"
                            :disabled="loading">Aceptar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <v-dialog transition="dialog-top-transition" persistent max-width="600" v-model="showDialogCita">
            <v-form ref="formCita" v-model="validCita" lazy-validation>
                <v-card>
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Alta Cita Telefónica</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text>
                        <v-row class="mb-8" style="margin-bottom: 0px !important; margin-top: 0px;">
                            <v-col md="12" cols="12">
                                <span style="font-weight: bold;">Tipo Cita:</span>
                                <br />
                                <span style="font-weight: bold; font-size: large;">Llamada telefónica</span>
                            </v-col>
                        </v-row>
                        <v-row class="mb-8" style="margin-bottom: 0px !important; margin-top: 0px;">
                            <v-col md="6" cols="12">
                                <span style="font-weight: bold;">Fecha Inicio:</span>
                                <v-dialog ref="dialogFhInicio" outlined v-model="modalFechaInicio"
                                    :return-value.sync="fechaInicio" persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="date-align-center">
                                            <v-text-field class="pt-2" v-model="fechaInicio" label="" outlined dense
                                                v-bind="attrs" v-on="on" readonly :rules="rulestextfechas">
                                            </v-text-field>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="fechaInicio" :min="minDateFhIni" locale="es" scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="secondary" @click="modalFechaInicio = false">Cancelar</v-btn>
                                        <v-btn text color="primary" @click="$refs.dialogFhInicio.save(fechaInicio)">
                                            Aceptar
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                            <v-col md="6" cols="12">
                                <span style="font-weight: bold;">Hora Inicio:</span>
                                <v-dialog ref="dialogHrIni" v-model="modalHrInicio" outlined
                                    :return-value.sync="timeInicio" persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field class="pt-2" v-model="timeInicio" label="" readonly
                                            :rules="rulestextfechas" outlined dense :disabled="disabledtimeInicio"
                                            v-bind="attrs" v-on="on" :filled="disabledtimeInicio"></v-text-field>
                                    </template>
                                    <v-time-picker v-if="modalHrInicio" v-model="timeInicio" :min="mintimeInicio"
                                        format="24hr" ampm-in-title scrollable full-width>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="secondary" @click="modalHrInicio = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text color="primary" @click="$refs.dialogHrIni.save(timeInicio)">
                                            Aceptar
                                        </v-btn>
                                    </v-time-picker>
                                </v-dialog>
                            </v-col>
                        </v-row>
                        <v-row style="margin-top: 0px;">
                            <v-col cols="12" md="12">
                                <span style="font-weight: bold;">Comentarios:</span>
                                <v-textarea class="pt-2 text-uppercase" :counter="500" maxlength="500"
                                    :rules="rulestextarea" outlined v-model="comentarios" required name="input-7-4"
                                    ref="comentarioField" @input="updateCampo('comentario', $event)"></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12" style="font-weight:bold">
                                <span color="#FF5C93">Se le notificará antes de su cita a través del sistema y, a la
                                    hora
                                    indicada, recibirá una notificación en la aplicación.</span>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" :disabled="btndisabledCita" @click="GuardarCita()">Aceptar</v-btn>
                        <v-btn @click="LimpiarDialogCita()" color="default" :disabled="btndisabledCita">Limpiar</v-btn>
                        <v-btn @click="CerrarDialogCita()" color="secondary" :disabled="btndisabledCita">Cerrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
    </v-container>
</template>

<script>
import Contacto from '@/services/DatosDeContacto/DatosContacto.service.js';
import { mapActions, mapState } from 'vuex';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import citas from '@/services/ControldeCitas/Citas.service.js';

export default {
    data: function () {
        return {
            telefonos: [],
            valid1: true,
            valid: true,
            showAgregar: false,
            showEditar: true,
            showEditarActor: true,
            permisoTelf: 0,
            validaConclusion: false,
            actores: {
                opcionesActores: [],
                staid: '',
                stadescripcion: ''
            },
            tipotelf: {
                opcionestipotelf: [],
                sttid: '',
                sttdescripcion: ''
            },
            validaActor: false,
            validaTipo: false,
            numtelf: '',
            numtelf2: '',
            prefijo: '',
            pais: '',
            validaTelefono: false,
            validaTelefonoSD: false,
            valagregar: true,
            errorTelf: [],
            telefonoFormat: null,
            phone: {
                number: '',
                valid: false,
                country: ''
            },
            disabledSave: false,
            disabledSaveA: false,
            nombre: null,
            horario: null,
            mostrarnomhorario: false,
            datosActor: [],
            valeditarActor: false,
            erroractor: null,
            staid_aux: 0,
            sinactores: false,
            sindefinir: false,
            telsindef: [],
            contactoInteligente: null,
            aiclave: null,
            modal: false,
            firma: '',
            ofuscar: 'OcultarTel',
            oculto: 'OcultarBtn',
            veri: true,
            ocultas: false,
            valid: true,
            msg: false,
            texto: '',
            loading: false,
            verTelefono: 0,
            tipoTel: '',
            permisoOfuscar: false,
            numtele: '',
            //Datos para IVR
            permisoIVR: false,
            ivr: null,
            LLamarSintiempo: false,
            datos: {},
            showMover: true,

            /* */
            validCita: true,
            btndisabledCita: false,
            showDialogCita: false,
            modalFechaInicio: false,
            fechaInicio: '',
            rulestextfechas: [v => !!v || 'Campo requerido'],
            minDateFhIni: '',
            fechaInicioV: '',
            modalHrInicio: false,
            timeInicio: '',
            disabledtimeInicio: true,
            mintimeInicio: '',
            comentarios: '',
            rulestextarea: [v => !!v || 'Campo requerido',
            v => {
                if (v == null) {
                    return true
                }
                else {
                    // return 'Mínimo 12 Carácteres'

                    if (v.length < 12) {
                        return 'Mínimo 12 Carácteres'
                    }
                    else if (v.length > 500) {
                        return 'Máximo 500 Carácteres'
                    }
                    else
                        return true
                }
            },
            ],
            fechaInicio1: '',
            fechaFin1: '',
            nrreporte: '',
            svindice: '',
            tipoCita: {
                tpcclave: {
                    tpcclave: 2
                }
            },
            telefonoCita: '',
            sending: false,
            permisoCita: false,
            permisoTelRepConcluido: false
        }
    },
    async mounted() {
        this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        this.aiclave = this.datos.aiclave;
        this.DatosContacto();
        let respuesta = await MetodosGenerales.getReporteEstatus(this);
        this.validaConclusion = respuesta != 1 ? false : true;
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '349').then(response => {
            if (response.data.length > 0) {
                this.permisoOfuscar = true;
            }
        });
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '35').then(response => {
            if (response.data.length > 0) {
                this.permisoCita = true;
            }
        });
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '394').then(response => {
            if (response.data.length > 0) {
                this.permisoTelRepConcluido = true;
            }
        });
        //Revisar Permisos IVR
        await this.DatosCI();


    },
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        },
    },
    watch: {
        'numtelf'(val) {
            this.validaTelefono = false;
            this.errorTelf = [];
        },
        'actores.staid'(val) {
            if (val.length != 0) {
                this.nombre = null
                this.horario = null
                this.validaActor = false;
                this.validaTelefono = false;
                this.obtenerDatosActor(val.staid)
            } else {
                this.mostrarnomhorario = false
            }

        },
        'tipotelf.sttid'(val) {
            this.validaTipo = false;
            this.validaTelefono = false;
        },
        'fechaInicio'(val) {
            if (val != null && val != '') {
                this.disabledtimeInicio = false;
                moment.locale("es-mx");

                let theDate = moment(val).format('ll');
                let fechad = new Date().toLocaleDateString('en-GB').split('/');
                let fechahoy = fechad[2] + '-' + fechad[1] + '-' + fechad[0];
                var fecha1 = moment(val, "YYYY-MM-DD HH:mm:ss");
                var fecha2 = moment(fechahoy, "YYYY-MM-DD HH:mm:ss");
                var startTime = new Date(fecha1);
                var endTime = new Date(fecha2);
                var difference = endTime.getTime() - startTime.getTime(); // This will give difference in milliseconds
                var resultInMinutes = Math.round(difference / 60000);
                let hours = new Date().getHours();
                let minuts = new Date().getMinutes();

                if (hours < 10) {
                    hours = "0" + hours;
                }
                if (minuts < 10) {
                    minuts = "0" + minuts;
                }
                if (resultInMinutes == 0) {
                    this.mintimeInicio = hours + ':' + minuts;
                }
                else {
                    this.mintimeInicio = '';
                }

                this.timeInicio = '';

            } else {
                this.disabledtimeInicio = true;
            }
        },
    },
    methods: {
        async EnviarMsj(numero) {
            var resp = await Contacto.EnviarSMS(this, numero);

            if (resp.error == false) {
                this.$swal({
                    position: 'center',
                    icon: 'success',
                    title: 'Éxito',
                    text: 'Mensaje enviado con éxito.',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) { }
                });

            }
            else {
                this.$swal({
                    position: 'center',
                    icon: 'error',
                    title: 'Ocurrio un error, intentelo más tarde.',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                    }
                });
            }

        },
        Foco() {
            this.msg = false;
        },
        VerModal(item, index, tipo) {
            this.numtele = item.stprefijo + ' ' + item.stnumero;
            this.verTelefono = index;
            this.modal = true;
            this.tipoTel = tipo;
        },
        CerrarModal() {
            this.modal = false;
            this.firma = '';
            this.texto = '';
        },
        ValidarFirma() {
            let formdatos = new FormData();
            formdatos.append("usfirma", this.firma);
            formdatos.append("telefono", this.numtele);
            if (this.firma.length == 0) {
                this.msg = true;
                this.texto = 'Campo de rquerido';
            }
            else if (this.firma.length < 8 || this.firma.length > 16) {
                this.msg = true;
                this.texto = 'El número de caracteres debe ser un mínimo de 8 y menor a 17';
            }
            else {
                this.loading = true;
                Contacto.ValidaFirmaElectronica(this, formdatos).then(dato => {
                    if (dato == 0) {
                        this.msg = true;
                        this.texto = 'Su firma electrónica es incorrecta';
                    }
                    else {
                        if (this.tipoTel == '') {
                            this.telefonos[this.verTelefono].verOculto = 1;
                            this.telefonos[this.verTelefono].showEditar = 5;
                        }
                        else {

                            this.telsindef[this.verTelefono].verOculto = 1;
                            this.telsindef[this.verTelefono].showEditar = 5;
                        }
                        this.modal = false;
                        this.veri = false;
                    }
                    this.firma = '';
                    this.loading = false;
                });
            }
        },
        OcultaTel(item, index, tipo) {
            if (tipo == '') {
                this.telefonos[index].verOculto = 0;
                this.telefonos[index].showEditar = 0;
            }
            else {
                this.telsindef[index].verOculto = 0;
                this.telsindef[index].showEditar = 0;
            }
        },
        async DatosContacto() {
            Contacto.ObtenerContactoInteligente(this);
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '285').then(response => {
                if (response.data.length > 0) {
                    this.permisoTelf = 1;
                }
            });
            Contacto.obtenerActores(this);
            Contacto.obtenerTiposTelf(this);

            Contacto.Telefonos(this).then(datostel => {
                this.telefonos = []
                let auxtelefonos = datostel;
                for (let i in auxtelefonos) {
                    for (const [key, value] of Object.entries(auxtelefonos[i])) {
                        if (typeof value == "object") { auxtelefonos[i][key] = "" } else { auxtelefonos[i][key] = value.toString() }
                    }
                }
                this.telefonos = auxtelefonos;
            });

            Contacto.ObtenerInformacionActor(this).then(datosActor => {
                this.datosActor = []
                let auxtelefonos = datosActor;
                for (let i in auxtelefonos) {
                    for (const [key, value] of Object.entries(auxtelefonos[i])) {
                        if (typeof value == "object") { auxtelefonos[i][key] = "" } else { auxtelefonos[i][key] = value.toString() }
                    }
                }
                this.datosActor = auxtelefonos;
                this.sinactores = this.datosActor.length == 0 ? true : false
                if (this.sinactores == true) {
                    this.datosActor
                }

            })
            //Contacto.obtenerPermisoIVR(this).then(response => {
            //    if(response.upvalor != null){this.permisoIVR = true}
            //});

            Contacto.ObtenerTelSinDefinir(this).then(resp => {
                this.sindefinir = resp.length > 0 ? true : false
                this.telsindef = []
                let auxtelefonos = resp;
                for (let i in auxtelefonos) {
                    for (const [key, value] of Object.entries(auxtelefonos[i])) {
                        if (typeof value == "object") { auxtelefonos[i][key] = "" } else { auxtelefonos[i][key] = value.toString() }
                    }
                }
                this.telsindef = auxtelefonos;
            })
        },
        editaTelf(item, index) {
            if (this.telefonos[index].verOculto == 1) {
                this.validaTelefono = false;
                this.showEditar = false;
                this.showEditarActor = false;
                this.telefonos.forEach((value, index) => {
                    if (this.telefonos[index].verOculto == 0)
                        this.telefonos[index].showEditar = 0;
                });
                this.errorTelf = [];
                this.validaActor = false;
                this.validaTipo = false;
                this.telefonos[index].showEditar = 1;
                this.valagregar = false;
                this.actores.staid = { staid: this.telefonos[index].staid, stadescripcion: this.telefonos[index].stadescripcion };
                this.tipotelf.sttid = { sttid: this.telefonos[index].sttid, sttdescripcion: this.telefonos[index].sttdescripcion };
                this.numtelf = this.telefonos[index].stnumero2;
            }
            else {
                this.modal = true;
                this.verTelefono = index;
                this.numtele = item.stprefijo + ' ' + item.stnumero;
            }
        },
        editaTelfSinDef(item, index) {
            this.validaTelefonoSD = false;
            this.showEditar = false;
            this.showEditarActor = false;
            this.telsindef.forEach((value, index) => {
                if (this.telsindef[index].verOculto == 0)
                    this.telsindef[index].showEditar = 0;
            });
            this.errorTelf = [];
            this.validaActor = false;
            this.validaTipo = false;
            this.telsindef[index].showEditar = 1;
            this.valagregar = false;
            this.actores.staid = { staid: this.telsindef[index].staid, stadescripcion: this.telsindef[index].stadescripcion };
            this.tipotelf.sttid = { sttid: this.telsindef[index].sttid, sttdescripcion: this.telsindef[index].sttdescripcion };
            this.numtelf = this.telsindef[index].stnumero2;

        },
        onInput(formattedNumber, { number, valid, country }) {
            this.validaTelefono = false;
            this.telefonoFormat = formattedNumber;


            if (number.input == number.national) {
                this.errorTelf = [];
                this.phone.number = number.national;
                this.phone.valid = valid;
                this.phone.country = country && country.name;
            }
            else {
                this.errorTelf.push("Teléfono Inválido");
                this.phone.number = number.national;
                this.phone.valid = false;
                this.phone.country = country && country.name;
            }

        },
        countryChanged(country) {
            this.prefijo = country.dialCode;
            this.pais = country.iso2;
        },
        cancelarEdicion(item, index) {
            this.validaTelefono = false;

            if (this.telefonos[index].verOculto == 1)
                this.telefonos[index].showEditar = 5;
            else
                this.telefonos[index].showEditar = 0;

            this.valagregar = true;
            this.actores.staid = '';
            this.tipotelf.sttid = '';
            this.numtelf = '';
            this.showEditar = true;
            this.showEditarActor = true;
            this.errorTelf = [];
            //this.$refs.form1.reset();
            this.validaActor = false;
            this.validaTipo = false;
            this.mostrarnomhorario = false;
        },
        cancelarEdicionSD(item, index) {
            this.validaTelefono = false;
            //this.telsindef[index].showEditar = 0;
            if (this.telsindef[index].verOculto == 1)
                this.telsindef[index].showEditar = 5;
            else
                this.telsindef[index].showEditar = 0;
            this.valagregar = true;
            this.actores.staid = '';
            this.tipotelf.sttid = '';
            this.numtelf = '';
            this.showEditar = true;
            this.showEditarActor = true;
            this.errorTelf = [];
            //this.$refs.form1.reset();
            this.validaActor = false;
            this.validaTipo = false;
            this.mostrarnomhorario = false;
        },
        eliminaTelf(item, index) {
            this.$swal({
                position: 'center',
                icon: 'warning',
                title: '¿Está seguro de eliminar el teléfono?',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$swal({
                        position: 'center',
                        title: 'Eliminando teléfono ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });
                    let eliminar = await Contacto.eliminarContacto(this, item)
                    let tipo = await Contacto.EliminarActor(this, item.staid)
                    if (tipo == 0) {
                        setTimeout(async () => {
                            this.$swal.close();
                            if (eliminar) {
                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: 'Se eliminó el teléfono con éxito.',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                }).then((result) => {
                                    if (result.isConfirmed) { }
                                })
                                Contacto.Telefonos(this).then(datostel => {
                                    this.telefonos = datostel;
                                });
                            }
                        }, 6000);
                    }
                    let tarjetasactores = await Contacto.ObtenerInformacionActor(this);
                    this.datosActor = []
                    let auxtelefonos = tarjetasactores;
                    for (let i in auxtelefonos) {
                        for (const [key, value] of Object.entries(auxtelefonos[i])) {
                            if (typeof value == "object") { auxtelefonos[i][key] = "" } else { auxtelefonos[i][key] = value.toString() }
                        }
                    }
                    this.datosActor = auxtelefonos;
                    this.sinactores = this.datosActor.length == 0 ? true : false
                    if (this.sinactores == true) {
                        this.datosActor
                    }
                    if (tipo != 0) {
                        this.CambioPosicionActor(1)
                    }
                    Contacto.ObtenerTelSinDefinir(this).then(resp => {
                        this.sindefinir = resp.length > 0 ? true : false
                        this.telsindef = []
                        let auxtelefonos = resp;
                        for (let i in auxtelefonos) {
                            for (const [key, value] of Object.entries(auxtelefonos[i])) {
                                if (typeof value == "object") { auxtelefonos[i][key] = "" } else { auxtelefonos[i][key] = value.toString() }
                            }
                        }
                        this.telsindef = auxtelefonos;
                    })
                }
            })

        },
        agregarTelf() {
            this.telefonos.forEach((value, index) => {
                this.telefonos[index].showEditar = 0;
            });
            this.validaTelefono = false;
            this.errorTelf = [];
            this.showAgregar = true;
            this.valagregar = false;
        },
        cancelarAlta() {
            this.validaTelefono = false;
            this.showAgregar = false;
            this.valagregar = true;
            this.errorTelf = [];
            //this.$refs.form.reset();
            this.validaActor = false;
            this.validaTipo = false;
            this.numtelf = "";
            this.actores.staid = "";
            this.tipotelf.sttid = "";
            this.mostrarnomhorario = false;
        },
        limpiarCampos() {
            this.validaTelefono = false;
            this.actores.staid = '';
            this.tipotelf.sttid = '';
            this.numtelf = '';
            this.numtelf2 = '';
            this.disabledSave = false;
            this.errorTelf = [];
        },
        validacionAgregar() {
            this.disabledSave = true;
            this.$refs.form.validate();
            if (this.actores.staid != '' && this.tipotelf.sttid != '' && this.$refs.form.validate() && this.prefijo != '' && this.phone.valid == true) {

                this.guardarAlta()

            } else {
                this.disabledSave = false;
                if (this.actores.staid == '') {
                    this.validaActor = true;
                }
                if (this.tipotelf.sttid == '') {
                    this.validaTipo = true;
                }
                if (this.phone.valid == false && this.$refs.form.validate()) {
                    this.errorTelf.push("Teléfono Inválido");
                }
            }
        },
        async guardarAlta() {
            const stringWithoutNumbers = this.phone.number.replace(/[^0-9]+/g, "");
            this.numtelf2 = stringWithoutNumbers;

            this.$swal({
                position: 'center',
                title: 'Guardando teléfono, espere un momento...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            });
            var alta = await Contacto.altaContacto(this)
            if (alta[0][0] == '') {
                if (this.mostrarnomhorario == true) {
                    if (this.horario != null) { this.horario = this.horario.trim() }
                    if (this.nombre != null) { this.nombre = this.nombre.trim() }
                    var actor = await Contacto.insertarinfoactor(this)
                    if (actor.length > 0) {
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: 'Ocurrio un error, intentelo más tarde.',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                            }
                        })
                    }

                }
                this.$swal({
                    position: 'center',
                    icon: 'success',
                    title: 'Éxito',
                    text: 'Se guardó el teléfono con éxito.',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) { }
                })
                this.limpiarCampos();
                this.showAgregar = false;
                this.valagregar = true;
                this.errorTelf = [];
                Contacto.Telefonos(this).then(datostel => {
                    this.telefonos = datostel;
                });
                var infoactor = await Contacto.ObtenerInformacionActor(this)
                this.datosActor = []
                let auxtelefonos = infoactor;

                for (let i in auxtelefonos) {
                    for (const [key, value] of Object.entries(auxtelefonos[i])) {
                        if (typeof value == "object") { auxtelefonos[i][key] = "" } else { auxtelefonos[i][key] = value.toString() }
                    }
                }
                this.datosActor = auxtelefonos;
            } else if (alta[0][0] == 'El número de teléfono ya existe.') {
                this.$swal({
                    position: 'center',
                    icon: 'error',
                    title: alta[0][0],
                    showConfirmButton: true
                })
                this.disabledSave = false;
                this.numtelf = '';
            } else if (alta[0][0] == 'El número de teléfono es de Ausa.') {
                this.$swal({
                    position: 'center',
                    icon: 'error',
                    title: alta[0][0],
                    showConfirmButton: true
                })
                this.disabledSave = false;
                this.numtelf = '';
            }
        },
        async obtenerDatosActor(staid) {
            this.mostrarnomhorario = false
            if (staid != 10) {
                let respuesta = await Contacto.ObtenerInformacionActor(this, staid)
                this.mostrarnomhorario = respuesta.length == 0 ? true : false;
            }
        },
        async guardarEdicion(item, index) {
            this.disabledSave = true;
            this.$refs.form1.validate();
            if (this.actores.staid != '' && this.tipotelf.sttid != '' && this.$refs.form1.validate() && this.prefijo != '' && this.phone.valid == true) {
                const stringWithoutNumbers = this.phone.number.replace(/[^0-9]+/g, "");
                this.numtelf2 = stringWithoutNumbers;
                if (this.numtelf2.toString() != item.stnumero || this.actores.staid.staid != item.staid || this.tipotelf.sttid.sttid != item.sttid) {

                    this.$swal({
                        position: 'center',
                        title: 'Actualizando teléfono, espere un momento...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });
                    var actualizar = await Contacto.actualizarContacto(this, item)
                    if (actualizar[0][0] == 'Actualizado') {
                        let tipo = await Contacto.EliminarActor(this, item.staid)
                        if (tipo != 0) {
                            let tarjetasactores = await Contacto.ObtenerInformacionActor(this);
                            this.datosActor = []
                            let auxtelefonos = tarjetasactores;
                            for (let i in auxtelefonos) {
                                for (const [key, value] of Object.entries(auxtelefonos[i])) {
                                    if (typeof value == "object") { auxtelefonos[i][key] = "" } else { auxtelefonos[i][key] = value.toString() }
                                }
                            }
                            this.datosActor = auxtelefonos;
                            this.sinactores = this.datosActor.length == 0 ? true : false
                            if (this.sinactores == true) {
                                this.datosActor
                            }
                            if (tipo != 0) {
                                this.CambioPosicionActor(2)
                            }
                        }
                        if (this.mostrarnomhorario == true) {
                            if (this.horario != null) { this.horario = this.horario.trim() }
                            if (this.nombre != null) { this.nombre = this.nombre.trim() }
                            var actor = await Contacto.insertarinfoactor(this)
                            if (actor.length > 0) {
                                this.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Ocurrio un error, intentelo más tarde.',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                    }
                                })
                            }

                        }
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se actualizó el teléfono con éxito.',
                            allowOutsideClick: false,
                            showConfirmButton: true,
                        }).then((result) => {
                            if (result.isConfirmed) {
                            }
                        })
                        this.validaTelefono = false;
                        this.limpiarCampos();
                        this.showAgregar = false;
                        this.valagregar = true;
                        this.showEditar = true;
                        this.showEditarActor = true;
                        this.actores.staid = '';
                        this.tipotelf.sttid = '';
                        this.numtelf = '';
                        this.errorTelf = [];
                        let temTelefonos = this.telefonos;
                        await Contacto.Telefonos(this).then(datostel => {
                            this.telefonos = datostel;
                        });
                        temTelefonos.forEach((value, index) => {
                            if (temTelefonos[index].verOculto == 1) {
                                this.telefonos[index].showEditar = 5;
                                this.telefonos[index].verOculto = 1;
                            }
                        });
                        var infoactor = await Contacto.ObtenerInformacionActor(this)
                        this.datosActor = []
                        let auxtelefonos = infoactor;

                        for (let i in auxtelefonos) {
                            for (const [key, value] of Object.entries(auxtelefonos[i])) {
                                if (typeof value == "object") { auxtelefonos[i][key] = "" } else { auxtelefonos[i][key] = value.toString() }
                            }
                        }
                        this.datosActor = auxtelefonos;

                    }
                    else if (actualizar[0][0] == 'El número de teléfono ya existe.') {
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: actualizar[0][0],
                            showConfirmButton: true
                        })
                        this.disabledSave = false;
                        this.numtelf = '';
                    }
                }
                else {
                    this.disabledSave = false;
                    this.validaTelefono = true;
                }
            }
            else {
                this.disabledSave = false;
                if (this.actores.staid == '') {
                    this.validaActor = true;
                }
                if (this.tipotelf.sttid == '') {
                    this.validaTipo = true;
                }
                if (this.phone.valid == false && this.$refs.form1.validate()) {
                    this.errorTelf.push("Teléfono Inválido");
                }
            }

        },
        async guardarEdicionSD(item, index) {
            this.disabledSave = true;

            if (this.actores.staid.staid != 10 && this.tipotelf.sttid.sttid != 4) {
                this.numtelf2 = item.stnumero;
                this.prefijo = item.stprefijo;
                this.pais = item.country;

                if (this.actores.staid.staid != item.staid || this.tipotelf.sttid.sttid != item.sttid) {
                    this.$swal({
                        position: 'center',
                        title: 'Actualizando teléfono, espere un momento....',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });
                    var actualizar = await Contacto.actualizarContacto(this, item);
                    if (actualizar[0] == 'Actualizado') {
                        if (this.mostrarnomhorario == true) {
                            if (this.horario != null) { this.horario = this.horario.trim() }
                            if (this.nombre != null) { this.nombre = this.nombre.trim() }
                            var actor = await Contacto.insertarinfoactor(this)
                            if (actor.length > 0) {
                                this.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Ocurrio un error, intentelo más tarde.',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                    }
                                })
                            }

                        }
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se actualizó el teléfono con éxito.',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                            }
                        })
                        this.validaTelefono = false;
                        this.limpiarCampos();
                        this.showAgregar = false;
                        this.valagregar = true;
                        this.showEditar = true;
                        this.showEditarActor = true;
                        this.actores.staid = '';
                        this.tipotelf.sttid = '';
                        this.numtelf = '';
                        this.errorTelf = [];

                        Contacto.Telefonos(this).then(datostel => {
                            this.telefonos = datostel;
                        });
                        var infoactor = await Contacto.ObtenerInformacionActor(this)
                        this.datosActor = []
                        let auxtelefonos = infoactor;
                        for (let i in auxtelefonos) {
                            for (const [key, value] of Object.entries(auxtelefonos[i])) {
                                if (typeof value == "object") { auxtelefonos[i][key] = "" } else { auxtelefonos[i][key] = value.toString() }
                            }
                        }
                        this.datosActor = auxtelefonos;
                        let temTelefonos = this.telsindef;
                        await Contacto.ObtenerTelSinDefinir(this).then(resp => {
                            this.sindefinir = resp.length > 0 ? true : false
                            this.telsindef = []
                            let auxtelefonos = resp;
                            for (let i in auxtelefonos) {
                                for (const [key, value] of Object.entries(auxtelefonos[i])) {
                                    if (typeof value == "object") { auxtelefonos[i][key] = "" } else { auxtelefonos[i][key] = value.toString() }
                                }
                            }
                            this.telsindef = auxtelefonos;
                        })
                    }
                    else {
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: actualizar[0],
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        })
                        this.disabledSave = false;
                        this.numtelf = '';
                    }
                } else {
                    this.disabledSave = false;
                    this.validaTelefono = true;
                }
            } else {
                this.disabledSave = false;
                if (this.actores.staid.staid == 10) {
                    this.validaActor = true;
                }
                if (this.tipotelf.sttid.sttid == 4) {
                    this.validaTipo = true;
                }
            }

            if (this.telefonos[index].verOculto == 1)
                this.telefonos[index].showEditar = 5;
        },
        EditarActor(item, index) {
            this.showEditar = false;
            this.showEditarActor = false
            this.valeditarActor = true
            this.nombre = item.sanombre
            this.horario = item.sahorarios
            this.datosActor[index].showEditarActor = 1;
            this.valagregar = false
        },
        guardarEdicionActor(item, index) {

            //modificar por lo menos un campo
            if (item.sahorarios == this.horario && item.sanombre == this.nombre) {
                this.erroractor = 'Debe de modificar al menos un campo'
            } else {
                if (this.horario != null) { this.horario = this.horario.trim() }
                if (this.nombre != null) { this.nombre = this.nombre.trim() }

                this.erroractor = null
                this.$swal({
                    position: 'center',
                    title: 'Actualizando información del actor, espere un momento....',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });
                Contacto.EditarInformacionActor(this, item.staid).then(resp => {
                    if (resp.length == 0) {
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se actualizó la información del actor con éxito.',
                            allowOutsideClick: false,
                            showConfirmButton: true,
                        }).then((result) => {
                            if (result.isConfirmed) {
                            }
                        })
                        this.LimpiarcamposActor()
                        this.datosActor[index].showEditarActor = 0;
                        this.showEditarActor = true
                        Contacto.ObtenerInformacionActor(this).then(datosActor => {
                            this.datosActor = []
                            let auxtelefonos = datosActor;
                            for (let i in auxtelefonos) {
                                for (const [key, value] of Object.entries(auxtelefonos[i])) {
                                    if (typeof value == "object") { auxtelefonos[i][key] = "" } else { auxtelefonos[i][key] = value.toString() }
                                }
                            }
                            this.datosActor = auxtelefonos;
                        })
                    } else {
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: 'Error',
                            text: 'Currio un error, intentelo más tarde',
                            allowOutsideClick: false,
                            showConfirmButton: true
                        })
                    }
                })
                this.valagregar = true
                this.showEditar = true;
            }
        },
        cancelarEdicionActor(item, index) {
            this.showEditar = true;
            this.nombre = null
            this.horario = null
            this.erroractor = null
            this.valeditarActor = false
            this.datosActor[index].showEditarActor = 0;
            this.showEditarActor = true
            this.valagregar = true
        },
        LimpiarcamposActor() {
            this.nombre = null
            this.horario = null
        },
        async CambioPosicionActor(tipo) {
            let newposition = []
            for (let i = 0; i < this.datosActor.length; i++) {
                let actorposicion = { staid: this.datosActor[i].staid, posicion: (i + 1) }
                newposition.push(actorposicion)
            }
            if (newposition.length > 0) {
                if (tipo == 0) {
                    this.$swal({
                        position: 'center',
                        title: 'Actualizando orden, espere un momento....',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });

                }
                var respuesta = await Contacto.CambioPosicionActores(this, newposition)
                if (respuesta.length == 0 && tipo == 0) {
                    this.$swal({
                        position: 'center',
                        icon: 'success',
                        title: 'Éxito',
                        text: 'Se actualizó el orden de los actores con éxito.',
                        allowOutsideClick: false,
                        showConfirmButton: true,
                    }).then((result) => {
                        if (result.isConfirmed) {
                        }
                    })
                } else if (tipo == 2 && respuesta.length == 0) {
                } else {
                    this.$swal({
                        position: 'center',
                        icon: 'error',
                        title: 'Error',
                        text: 'Currio un error, intentelo más tarde',
                        allowOutsideClick: false,
                        showConfirmButton: true
                    })
                }
                if (tipo == 1) {
                    this.$swal({
                        position: 'center',
                        icon: 'success',
                        title: 'Éxito',
                        text: 'Se eliminó el teléfono y se reordenaron los actores con éxito.',
                        allowOutsideClick: false,
                        showConfirmButton: true,
                    }).then((result) => {
                        if (result.isConfirmed) {
                        }
                    })
                }
            } else { //cuando es el ultimo teléfono
                this.$swal({
                    position: 'center',
                    icon: 'success',
                    title: 'Éxito',
                    text: 'Se eliminó el teléfono con éxito.',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) { }
                })
            }
        },
        async CambioOrdenTel(actor) {
            this.staid_aux = actor
            let telefonosactor = []
            let newposition = []
            let orden = []
            let stid = []
            telefonosactor = this.telefonos.filter(telefono => telefono.staid == actor)
            for (let i = 0; i < telefonosactor.length; i++) {
                stid.push(telefonosactor[i].stid)
                orden.push(parseInt(telefonosactor[i].stconsecutivotel))
            }
            //orden = orden.sort()
            var ordenaux = orden.sort((a, b) => {
                return a - b;
            });
            this.$swal({
                position: 'center',
                title: 'Actualizando, espere un momento....',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            });
            var respuesta = await Contacto.CambioPosicionTelefonos(this, orden, stid)
            if (respuesta == 'OK') {
                this.$swal({
                    position: 'center',
                    icon: 'success',
                    title: 'Éxito',
                    text: 'Se actualizó el orden de los teléfonos con éxito.',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                    }
                })
            } else {
                this.$swal({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: 'Currio un error, intentelo más tarde',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                })
            }
            this.staid_aux = 0
        },
        async DatosCI() {

            let responseIVR = await Contacto.ObtenerCodigoIVR(this); //ObtenerIVR

            this.ivr = responseIVR[0].IVR;

            if (responseIVR[0].SINTIEMPO == 'SI') {

                this.LLamarSintiempo = true;

            }


            let diasConclu = await Contacto.ObtenerDiasConcluidos(this);


            if (this.ivr != 0 && diasConclu < 30) {

                //Habilitar permiso IVR
                this.permisoIVR = true;
            }
            else if (this.LLamarSintiempo && this.ivr != 0) {

                this.permisoIVR = true;
            }

            this.$store.commit("changeivrPermiso", this.permisoIVR, this.ivr);
            this.$store.commit("changeivrNum", this.ivr);

        },
        async LlamadaIVR(telefono) {
            let actor = await Contacto.ObtenerTipoActor(this, telefono.stadescripcion);
            /* this.ivr*/
            /*validar primero el ivr */
            Contacto.LlamadaIVRServ(this, telefono.stnumero, actor).then(datostel => {
                if (datostel !== null) {
                    window.location = 'tel:' + datostel;
                }
            })
        },
        ocultartele(telefono, ban) {
            if (!ban) {
                let chars = 0; // Cantidad de caracters visibles
                return telefono.split('').slice(chars, -1).map(v => '*').join('');
            }
            else
                return telefono;
        },
        separarNumeroTelefono(cadena) {
            let caracter = '-';
            let pasos = 2;
            let cadenaConCaracteres = "";
            const longitudCadena = cadena.length;
            for (let i = 0; i < longitudCadena; i += pasos) {
                if (i + pasos < longitudCadena) {
                    cadenaConCaracteres += cadena.substring(i, i + pasos) + caracter;
                } else {
                    cadenaConCaracteres += cadena.substring(i, longitudCadena);
                }
            }
            return cadenaConCaracteres;
        },
        async dialogCita(telefono) {
            this.telefonoCita = this.ocultartele(this.separarNumeroTelefono(telefono.stnumero.substring(0, 6)))
            let tel4dig = this.separarNumeroTelefono(telefono.stnumero.substring(6, 10));
            this.telefonoCita = this.telefonoCita + tel4dig;
            let response = await citas.obtenerFechaActual(this);
            this.minDateFhIni = response[0].today;
            this.showDialogCita = true;
        },
        CerrarDialogCita() {
            this.showDialogCita = false;
            this.LimpiarDialogCita();
        },
        LimpiarDialogCita() {
            this.$refs.formCita.reset();
            this.comentarios = '';
        },
        async GuardarCita() {
            this.$refs.formCita.validate()

            if (this.$refs.formCita.validate()) {
                this.comentarios = this.comentarios.trim();

                if (this.sending) { // Verifica si ya se está enviando
                    return; // Si es así, no hace nada
                }
                this.sending = true;

                this.fechaInicio1 = this.fechaInicio + ' ' + this.timeInicio;
                let fechaInicio1Moment = moment(this.fechaInicio1 + ' ' + this.timeInicio, "YYYY-MM-DD HH:mm");
                // Sumar una hora
                fechaInicio1Moment.add(1, 'hour');
                // Obtener la nueva fecha y hora
                let fechaFin = fechaInicio1Moment.format("YYYY-MM-DD HH:mm");
                this.fechaFin1 = fechaFin;

                this.nrreporte = this.datos.nrreporte;
                this.svindice = this.datos.svindice;
                let response = await citas.validarCita(this);
                if (!response) {
                    this.$swal({
                        position: 'center',
                        title: 'Guardando Cita, espere un momento....',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });
                    this.comentarios = this.comentarios + ' // ' + this.telefonoCita;
                    let response2 = await citas.guardarCita(this);
                    if (response2.success) {
                        let fechanoti = moment(this.fechaInicio1 + ' ' + this.timeInicio, "YYYY-MM-DD HH:mm");
                        fechanoti.subtract(5, 'minutes');
                        // Obtener la nueva fecha y hora
                        let fechaNotificacion = fechanoti.format("YYYY-MM-DD HH:mm");

                        let fechaAux = this.fechaInicio + ' ' + this.timeInicio;
                        let response3 = await Contacto.EnviarNotificacion(this, response2.result, fechaNotificacion, fechaAux);
                        if (response3) {
                            this.$swal.close();
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se guardó y se notificará la cita con éxito.',
                                showConfirmButton: true,
                                timer: 3000
                            }).then((result) => {
                                this.CerrarDialogCita();
                            })
                        } else {
                            this.$swal.close();
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se guardó con éxito, pero ocurrió un error al notificar la cita.',
                                showConfirmButton: true,
                                timer: 3000
                            }).then((result) => {
                                this.CerrarDialogCita();
                            })
                        }
                    }
                }
                else {
                    this.disabledSave = false;
                    this.$swal({
                        position: 'center',
                        icon: 'error',
                        title: 'Ya existe otra cita agendada en la fecha y hora selecionada.',
                        showConfirmButton: true,
                    });
                }
                this.sending = false;
            }
        },
        async updateCampo(campo, newValue) {
            if (newValue != null) {
                const input = this.$refs[campo + 'Field'].$el.querySelector('textarea');
                if (!input) {
                    return;
                }
                const selectionStart = input.selectionStart;
                const selectionEnd = input.selectionEnd;
                this.comentarios = newValue.toUpperCase();
                // Restaurar la posición del cursor
                this.$nextTick(() => {
                    input.setSelectionRange(selectionStart, selectionEnd);
                });
            }
        },
    },

}
</script>
<style scope>
#actornombre .list-titles {
    max-width: -webkit-fill-available !important;
}

.OcultarTel {
    -webkit-text-security: disc;
}

.OcultarBtn {
    display: none;
}

.hoverTel:hover {
    background-color: lightskyblue;
    cursor: pointer;
}
</style>